<template>
    <div class="serch-page-content pb-20">
        <div class="row">
            <div class="col-12">
                <div class="search-form">
                    <div class="search-input-wrap">
                        <i class="ico-search icon-lable"></i>
                        <input class="form-control" type="search" v-model="search" placeholder="Search by …" @keydown.enter="result()" />
                        <button class="reset-btn" @click="search = ''" type="button"><i class="ico-close"></i></button>
                    </div>
                </div>
                <div class="nav-tabs-wrap">
                    <ul class="nav nav-tabs" role="tablist" style="cursor: pointer">
                        <li>
                            <a :class="{ active: activeTab == 'all' }" @click="activeTab = 'all'">All</a>
                        </li>
                        <li>
                            <a :class="{ active: activeTab == 'teams' }" @click="activeTab = 'teams'">Teams</a>
                        </li>
                        <li>
                            <a :class="{ active: activeTab == 'players' }" @click="activeTab = 'players'">Players</a>
                        </li>
                        <li>
                            <a :class="{ active: activeTab == 'leagues' }" @click="activeTab = 'leagues'">Leagues</a>
                        </li>
                        <li>
                            <a :class="{ active: activeTab == 'articles' }" @click="activeTab = 'articles'">Articles</a>
                        </li>
                        <li>
                            <a :class="{ active: activeTab == 'videos' }" @click="activeTab = 'videos'">Videos</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content text-center" v-if="! is_data_ready">
                    <span class="loader"></span>
                </div>
                <div class="tab-content" v-else>
                    <section class="card-play-section" v-if="activeTab == 'all' || activeTab == 'teams'">
                        <strong class="h2 text-uppercase">Teams</strong>
                        <div v-if="!teams.length">
                            <p>No team data found.</p>
                        </div>
                        <div class="row card-play-holder" v-else>
                            <div class="col-sm-6 col-md-4 col-lg-3 card-play" v-for="team in teams" :key="team.id">
                                <router-link :to="{ name: 'TeamDetails.Players', params:  {  team: team.slug} }">
                                    <div class="icon-logo"><img width="42" height="42" class="lazyload" :src="team.flag ? team.flag.resizeImage(42,42) : ''" alt="logo" /></div>
                                    <div class="info">
                                        <strong class="title">{{ team.name }}</strong>
                                        <span class="sub-title">{{ team.country }}</span>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </section>
                    <section class="card-play-section" v-if="activeTab == 'all' || activeTab == 'players'">
                        <strong class="h2 text-uppercase">Players</strong>
                        <div v-if="!players.length">
                            <p>No players data found.</p>
                        </div>

                        <div class="row card-play-holder" >
                            <div class="col-sm-6 col-md-4 col-xl-3 card-play players" v-for="player in players" :key="player.id">
                                <router-link :to="{ name: 'playerDetail.info', params: { player: player.slug } }">


                                    <div class="icon-logo" v-if="player.gender == 'male' || player.gender == 'Male'  || player.gender == 'M' || player.gender == 'MALE'"><img :src="('https://img.sixlogics.com/avatars/cricket/players/300x300/'+player.id+'.png').resizeImage(90)"   @error="$event.target.src='/public/images/User_Male.jpg'" alt=""></div>
                                    <div class="icon-logo" v-else-if=" player.gender == 'female' || player.gender == 'F' || player.gender == 'FEMALE'| player.gender == 'Female'"><img :src="('https://img.sixlogics.com/avatars/cricket/players/300x300/'+player.id+'.png').resizeImage(90)"   @error="$event.target.src='/public/images/User_Female.jpg'" alt=""></div>
                                    <div class="icon-logo" v-else><img :src="('https://img.sixlogics.com/avatars/cricket/players/300x300/'+player.id+'.png').resizeImage(90)"   @error="$event.target.src='/public/images/User_Male.jpg'" alt=""></div>

                                    <div class="info">
                                        <span class="icon-flag"><img :title="player.country.name" :src="'https://api.planetcricket.com/storage/country_flags/'+ player.country_id +'.png'" alt=""></span>
                                        <strong class="title d-none d-md-block">{{player.name}} </strong>
                                        <strong class="title d-md-none">{{player.short_name}} </strong>
                                        <ul class="descrip-list">
                                            <li>
                                                <!-- <span class="title">Gender</span> -->
                                                <span class="sub-title">
                                                    <span class="text">{{player.gender = player.gender.charAt(0).toUpperCase() + player.gender.slice(1) }}</span>
                                                </span>
                                            </li>
                                            <!-- <li>
                                                <span class="title">Country</span>
                                                <span class="sub-title">
                                                    <span class="text"></span>
                                                    <span class="icon-flag"><img :src="'https://cric.livescoring.cc/teamflags/'+player.country_id+'png'"></span>
                                                </span>
                                            </li> -->
                                            <li>
                                                <!-- <span class="title">Playing role</span> -->
                                                <span class="sub-title">
                                                    <span class="text">{{player.role = player.role.charAt(0).toUpperCase() + player.role.slice(1)}}</span>
                                                </span>
                                            </li>
                                            <li> 
                                                <!-- <span class="title">DOB</span> -->
                                                <span class="sub-title">
                                                    <span class="text">{{player.age ? player.age:'0'}} Years</span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </router-link> 
                            </div>
                        </div>
                    </section>



                    <section class="card-play-section" v-if="activeTab == 'all' || activeTab == 'leagues'">
                        <strong class="h2 text-uppercase">Leagues</strong>
                        <div v-if="!tournaments.length">
                            <p>No league data found.</p>
                        </div>
                        <div class="row card-play-holder" v-else>
                            <div class="col-sm-6 col-md-4 col-lg-3 card-play league" v-for="tournament in tournaments" :key="tournament.id">
                                <router-link :to="{ name: 'tournamentDetail.Matches', params: { tournament: tournament.slug } }">
                                    <div class="icon-logo"><img width="183" height="26" class="lazyload" :src="require('@/assets/images/league-logo-placeholder.jpg')" alt="logo" /></div>
                                    <div class="info">
                                        <strong class="title">{{ tournament.name }}</strong>
                                        <span class="sub-title" v-if="tournament.teams_count">{{ tournament.teams_count }} Teams</span>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </section>
                    <section class="post-section" v-if="activeTab == 'all' || activeTab == 'articles'">
                        <div class="post-section-head">
                            <strong class="h2 text-uppercase">Articles</strong>
                            <router-link :to="{ name: 'newsList' }" class="see-all">See All</router-link>
                        </div>
                        <div v-if="articles.length == 0">
                            <p>No article data found.</p>
                        </div>
                        <VueSlickCarousel v-else class="post-slider" :arrows="true" :dots="false" :variableWidth="true" :infinite="false">
                            <div class="slide" v-for="article in articles" :key="article.id">
                                <div class="post">
                                    <router-link
                                        :to="{ name: 'newsArticle', params: { news: article.slug, ...(article.match) && {match: article.match.slug} } }"
                                        >
                                        <div class="img-holder">
                                            <img width="260" height="130" loading="lazy" :src="article.image_url.resizeImage(260,130)" alt="image description" />
                                        </div>
                                        <div class="descrip">
                                            <h3>{{ article.heading }}</h3>
                                            <time class="time" :datetime="article.created_at | formatDate">
                                                  {{ article.created_at | timeElaped }}
                                        </time>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </VueSlickCarousel>
                </section>
                <section class="post-section" v-if="activeTab == 'all' || activeTab == 'videos'">
                    <div class="post-section-head">
                        <strong class="h2 text-uppercase">Videos</strong>
                        <router-link :to="{ name: 'highlights' }" class="see-all">See All</router-link>
                    </div>
                    <div v-if="!videos.length">
                        <p>No video data found.</p>
                    </div>
                    <VueSlickCarousel v-else class="post-slider" :arrows="true" :dots="false" :variableWidth="true" :infinite="false">
                        <div class="slide" v-for="video in videos" :key="video.id">
                            <div class="post">
                                <a href="javascript:;">
                                    <div class="img-holder">
                                        <span v-html="video.highlight"></span>
                                    </div>
                                    <div class="descrip">
                                        <time class="time" :datetime="videos.created_at | formatDate">{{
												videos.created_at | timeElaped
                                              }}</time>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </VueSlickCarousel>
                </section>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import Vue from 'vue'
    import moment from 'moment'
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        name: 'search',

        components: {VueSlickCarousel},

        data() {
            return {
                search: '',
                teams: [],
                articles: [],
                tournaments: [],
                videos: [],
                players: [],
                activeTab: 'all',
                age: ''

            }
        },

        watch: {
            '$route.query.search'() {
                if(isBrowser){
                    this.search = this.$route.query.search
                    this.getSearchResult()
                }
            }
        },
        metaInfo() {
            let title = "All Cricket Matches, Score, Update, Schedule, Upcoming";
            let description = "Get all the latest cricket news, live scores, results, match schedules, articles, player & team updates, and cricket videos - PlanetCricket";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                this.search = this.$route.query.search
                return this.getSearchResult();
            }
        },

        mounted() {
            this.search = this.$route.query.search
            this.getSearchResult()
        },

        methods: {
            result() {

                this.$router.push({path: 'search', query: {search: this.search}})
                this.getSearchResult();

            },
            getSearchResult() {
                if (!this.search)
                    return
                this.is_data_ready = false
                return this.$axios
                        .get(this.$GENERAL_SEARCH_API, {params: {q: this.search, ttl: 0}})
                        .then(response => {
                            this.is_data_ready = true
                            this.teams = response.data.result.teams || []
                            this.players = response.data.result.players || []
                            this.articles = response.data.result.articles || []
                            this.tournaments = response.data.result.tournaments || []
                            this.videos = response.data.result.videos || []

                            for (let i = 0; i < this.players.length; i++) {

                                this.players[i].dob = moment(String(this.players[i].dob)).format('YYYY-MM-DD');
                                this.players[i].age = this.ageCalculate(this.players[i].dob);
                            }
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
            ageCalculate(DOB) {
                var date = new Date().toISOString().slice(0, 10);
                var datee = moment(date).format('YYYY-MM-DD');
                if (DOB < datee)
                {
                    return  this.age = Vue.filter('age')(DOB);
                } else
                {
                    return this.age = '';
                }

            }


        }
    }
</script>
